import { ActionIcon, Button, Group, Modal, Select, Switch, Text, TextInput, UnstyledButton } from '@mantine/core';
import * as React from 'react';
import { useAuth } from "../contexts/auth.context";
import InputField, { InputFieldTypes } from './input_field';
import { useNavigate } from 'react-router-dom';
import { CREATE_CHILDREN } from '../services/companies';
import { showNotification } from '@mantine/notifications';
import { FaPlus } from 'react-icons/fa';
import { groupBy } from '../utility/util';
import { useMediaQuery } from '@mantine/hooks';

export default function RolesSelect({ refresh = false, onChange = null }){
    const { currentCompany, companies, onChangeCompany, loadUserData, userData } = useAuth();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 900px)');

    const [modal, setModal] = React.useState(null);
    const [loadingSave, setLoadingSave] = React.useState(false);

    const handleSave = () => {
      setLoadingSave(true);
      CREATE_CHILDREN(modal)
      .then(() => {
          setLoadingSave(false)
          loadUserData();
          setModal(null);
      })
      .catch(err => {
          setLoadingSave(false);
          showNotification({message: err.message, color: 'red'});
      })
  }

  return <>
    <Modal
      opened={!!modal}
      onClose={() => setModal(null)}
    >
      {userData?.user?.isAdmin && <Switch label="Cliente Satify" value={modal?.master} onChange={() => setModal(fd => ({...fd, master: !fd.master}))} />}
      {!modal?.master && userData?.user?.isAdmin && <Select
        mt="md"
        label="Master"
        name="parent"
        value={modal?.parent}
        onChange={parent => setModal(fd => ({ ...fd, parent }))}
        data={
          companies
          .filter(c => c.company.master)
          .map(c => ({ label: c.company.name.toUpperCase(), value: c.company._id, }))
        }
      />}
      <Select
        mt="md"
        label="Tipo da empresa"
        name="type"
        value={modal?.type}
        onChange={type => setModal(fd => ({ ...fd, type }))}
        data={[
          {label: "Empresa Privada", value: "empresa-privada"},
          {label: "Órgão Público", value: "orgao-publico"},
          {label: "Frente Parlamentar", value: "frente-parlamentar"},
          {label: "Parlamentar", value: "parlamentar"},
          {label: "Partido Político", value: "partido"},
          {label: "Outros", value: "outro"},
        ]}
      />
      <TextInput mt="md" label="Nome" name="name" value={modal?.name} onChange={(e) => setModal(m => ({ ...m, name: e.target.value }))} />
      <TextInput mt="md" label="Label" name="label" value={modal?.label} onChange={(e) => setModal(m => ({ ...m, label: (e.target.value ?? "").toLowerCase().replace(/\@| |\_/g, "-") }))} />
      <TextInput mt="md" label="CPF ou CNPJ" name="cnpj" value={modal?.cnpj} onChange={(e) => setModal(m => ({ ...m, cnpj: e.target.value }))} />
      <TextInput mt="md" label="Telefone ou celular" name="phone" value={modal?.phone} onChange={(e) => setModal(m => ({ ...m, phone: e.target.value }))} />
      <TextInput mt="md" label="E-mail" name="email" type="email" value={modal?.email} onChange={(e) => setModal(m => ({ ...m, email: e.target.value }))} />

      <Group position='right' mt="lg">
        <Button disabled={loadingSave} onClick={() => setModal(null)} variant='outline' color="gray">Cancelar</Button>
        <Button loading={loadingSave} onClick={handleSave} variant='filled'>Salvar</Button>
      </Group>
    </Modal>
    <Group>
      {(companies.length > 1 || currentCompany?.company?.master) ? <>
        <Select
          style={{flex: 1}}
          styles={{input: {minWidth: isMobile ? '100%' : 300}}}
          data={
            companies
            .filter(c => c.company.master)
            .sort((a,b) => a.company.name > b.company.name ? 1 : -1)
            .reduce((pv, master) => {
              return [
                { label: master.company.name.toUpperCase(), value: master.company._id, group: master.company.name.toUpperCase() },
                ...pv.concat((master.company.children ?? []).map(c => ({
                  value: c._id, label: c.name ?? "".toUpperCase(), group: master.company.name.toUpperCase()
                })))
              ].sort((a,b) => a.label > b.label ? 1 : -1)
            },[])
          }
          value={currentCompany?.company?._id}
          name="companyId"
          itemComponent={({label, ...others}) => <UnstyledButton {...others}>
            <Text size="xs">{label}</Text>
          </UnstyledButton>}
          clearable={false}
          searchable
          onChange={(companyId) => {
            if(companyId){
              onChange && onChange(companyId);
              onChangeCompany(companyId, refresh)
            }
          }}
        >
        </Select>
      </>
      : <Text style={{flex: 1}} size="sm" p="xs">{currentCompany?.company?.name}</Text>}
      {
        (userData?.user?.isAdmin || (
          currentCompany?.company?.master &&
          !["Motorista", "Cliente"].includes(userData?.user?.currentCompany?.role?.profile?.title)
        )) &&
        <ActionIcon variant='outline' color="gray" size="lg" onClick={() => setModal({})}><FaPlus /></ActionIcon>
      }
    </Group>
  </>
}